export default __webpack_public_path__ + "static/media/BCA15.e532a0cd.jpg";